/*
 *  Copyright (c) 2012-2021 Grab Taxi Holdings PTE LTD (GRAB), All Rights Reserved. NOTICE: All information contained herein
 *  is, and remains the property of GRAB. The intellectual and technical concepts contained herein are confidential, proprietary
 *  and controlled by GRAB and may be covered by patents, patents in process, and are protected by trade secret or copyright law.
 *
 *  You are strictly forbidden to copy, download, store (in any medium), transmit, disseminate, adapt or change this material
 *  in any way unless prior written permission is obtained from GRAB. Access to the source code contained herein is hereby
 *  forbidden to anyone except current GRAB employees or contractors with binding Confidentiality and Non-disclosure agreements
 *  explicitly covering such access.
 *
 *  The copyright notice above does not evidence any actual or intended publication or disclosure of this source code,
 *  which includes information that is confidential and/or proprietary, and is a trade secret, of GRAB.
 *
 *  ANY REPRODUCTION, MODIFICATION, DISTRIBUTION, PUBLIC PERFORMANCE, OR PUBLIC DISPLAY OF OR THROUGH USE OF THIS SOURCE
 *  CODE WITHOUT THE EXPRESS WRITTEN CONSENT OF GRAB IS STRICTLY PROHIBITED, AND IN VIOLATION OF APPLICABLE LAWS AND
 *  INTERNATIONAL TREATIES. THE RECEIPT OR POSSESSION OF THIS SOURCE CODE AND/OR RELATED INFORMATION DOES NOT CONVEY
 *  OR IMPLY ANY RIGHTS TO REPRODUCE, DISCLOSE OR DISTRIBUTE ITS CONTENTS, OR TO MANUFACTURE, USE, OR SELL ANYTHING
 *  THAT IT MAY DESCRIBE, IN WHOLE OR IN PART.
 *
 */


import React, { useState } from 'react'
import { Input, message, Tooltip } from 'antd'
import { SearchOutlined } from '@ant-design/icons'
import classnames from 'classnames'
import { Marker } from 'react-mapbox-gl'
import locationPng from 'assets/images/marker/drop-off-green.svg'
import ReactDOM from 'react-dom'
import { validateGeoPoints } from '../../utils/map'

const {Search} = Input

const TargetPoint = props =>{
  const {container, data } = props;
  if (!data) return null
  return ReactDOM.createPortal(
    <Marker  coordinates={data} anchor="bottom">
      <img
        src={locationPng}
        style={{ zoom: 1}}
        alt='icon'
      />
    </Marker>,
  container
)
}

const PhotoInvestigation = props => {
  const {  map } = props
  const [actived, setActiveD] =useState(true)
  const [currentLocation, setCurrentLocation]= useState(null)
  const handleClick = ()=>{
    setActiveD(!actived)
  }
  const handleSearch = (event)=>{
    if (event === '') return
    const location = event.replace(/\s/g,'').split(',')
    console.log(event,location)
    if(location.length === 1){
      message.info('please use english comma split longitude and latitude')
      return
    }
    const result =validateGeoPoints(location)
    if(map && result){
      setCurrentLocation(location.map(item=>Number(item)))
      map.panTo(location,{duration: 200})
    }
  }
  return (
    <>
      <Tooltip title='Open GPS Search'>
        <button className={classnames({'actived': actived})} onClick={handleClick}>
         <SearchOutlined />
        </button>
      </Tooltip>
      <div className={classnames('map-search',{'show': actived})}>
        <Search
          placeholder={'coordinates eg longitude,latitude'}
          allowClear
          // enterButton="Search"
          size="small"
          style={{ width: 280}}
          onSearch={handleSearch}
        />
      </div>
      <TargetPoint data={currentLocation} container={map?.getContainer()}/>
    </>
  )
}
export default PhotoInvestigation
